import styled from "styled-components";
import { BaseGridContainer } from "../../utils/styles";

export const ProductsWrap = styled(BaseGridContainer)`
	height: auto;
	margin: 0 auto 12px auto;
`;

export const ProductCardWrap = styled.section``;
